import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { Typography } from 'antd';
import {
  ProjectsConstructorLayout,
  useNavigateConstructorTabs,
  ProjectsAddEpicGroupForm,
  EpicGroupCardsList,
  ProjectConstructorNavigationControls,
} from '@/views';
import { ProjectDto } from '@/core';
import classes from './ProjectsEpicGroupsPage.module.scss';

export const ProjectsEpicGroupsPage = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const projectData = useOutletContext<ProjectDto>();
  const { navigateToNextTab, navigateToPreviousTab } = useNavigateConstructorTabs(projectData);

  return (
    <ProjectsConstructorLayout
      projectData={projectData}
      content={
        <>
          <Typography.Title level={3}>
            {projectData?.name}: {t('addEpicGroups.title')}
          </Typography.Title>
          <Typography.Text type="secondary" className={classes.pageDescription}>
            {t('addEpicGroups.description')}
          </Typography.Text>
          <ProjectsAddEpicGroupForm projectData={projectData} />
          <EpicGroupCardsList projectData={projectData} />
        </>
      }
      navigationControls={
        <ProjectConstructorNavigationControls
          navigateToPreviousTab={navigateToPreviousTab}
          navigateToNextTab={navigateToNextTab}
        />
      }
    />
  );
};
